/**
 * @file
 * Theme javascript.
 */
(function ($, once) {
  function isMobile() {
    return window.innerWidth < 1280;
  }

  function isDesktop() {
    return window.innerWidth >= 1280;
  }

  function toggleAttr(el, attrName) {
    el.attr(attrName, function (i, attr) {
      return attr === 'true' ? 'false' : 'true';
    });
  }

  function reInitSlick(slider, parameter, breakpoint = 768) {
    $(window).on('resize', function () {
      if ($(window).width() <= breakpoint) {
        if (!$(slider).hasClass('slick-initialized')) {
          $(slider).slick(parameter);
        }
      }
    });
  }

  function movePrevBtnBeforeAfterSlick(slider) {
    $(slider).on('init', function () {
      const $prevButton = $('.slick-prev', this);
      const $nextButton = $('.slick-next', this);

      $prevButton.insertBefore($nextButton);
    });
  }

  function addFocusableLink(slider) {
    $(slider).on('init', function () {
      setTimeout(() => {
        $(this).find('.slick-slide .node > a').attr('tabindex', '0');
      }, 0);
    });
  }

  function customDotsAccessibilityTxt(index) {
    return (
      `<button type="button">` +
      `<span class="slick-sr-only">Aller à la slide ${
        index + 1
      }</span></button>`
    );
  }

  // Basic functions to get/set cookies.
  function setCookie(cname, cvalue) {
    const now = Date.now('GMT+1');
    const nextMidnight = new Date(now).setUTCHours(24, 0, 0, 0);
    const expires = new Date(nextMidnight).toUTCString();
    document.cookie = `${cname}=${cvalue};expires=${expires};path=/`;
  }

  function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  Drupal.behaviors.header = {
    attach(context) {
      once(
        'header',
        '.block-ville-saint-denis-common-menu-main',
        context,
      ).forEach((mainNav) => {
        const bodyElt = context.querySelector('body');
        const htmlElt = context.querySelector('html');
        const header = mainNav.closest('.site-header');

        // MOBILE NAVIGATION
        if (isMobile()) {
          const quickLinkMenu = context.querySelector(
            '.block-ville-saint-denis-common-menu-rapide',
          );
          const menuItems = mainNav.querySelectorAll('.menu__item');
          const levelOneLinks = mainNav.querySelectorAll(
            '.-level-1 > .menu__item > span.menu__item__link',
          );
          const levelTwoLinks = mainNav.querySelectorAll(
            '.-level-2 > .menu__item > span.menu__item__link',
          );

          const toggleMobileNav = function (e) {
            const mobileNavBtn = e.target.closest('.menu-burger');

            if (!mobileNavBtn) return;

            const isMobileNavOpen =
              mobileNavBtn.getAttribute('aria-expanded') === 'true';

            mobileNavBtn.setAttribute('aria-expanded', !isMobileNavOpen);
            bodyElt.classList.toggle('-menu-opened');

            htmlElt.classList.toggle('-fixed-screen');

            if (mobileNavBtn.getAttribute('aria-expanded') === 'true') return;

            levelOneLinks.forEach((link) =>
              link.setAttribute('aria-expanded', 'false'),
            );
            levelTwoLinks.forEach((link) =>
              link.setAttribute('aria-expanded', 'false'),
            );
            menuItems.forEach((item) => item.classList.remove('-open'));
            const backToMainMenuBtns =
              mainNav.querySelectorAll('.menu__return-link');
            if (backToMainMenuBtns) {
              backToMainMenuBtns.forEach((btn) => btn.remove());
            }
          };

          const showLevelTwo = function () {
            if (this.getAttribute('aria-expanded') === 'true') return;
            this.setAttribute('aria-expanded', 'true');
            this.closest('.menu__item').classList.add('-open');

            const backToMainHtml = `
              <button class="menu__return-link" type="button">${Drupal.t(
                'Menu principal',
              )}</button>
            `;
            this.closest('.menu__item').insertAdjacentHTML(
              'afterbegin',
              backToMainHtml,
            );
          };

          const hideLevelTwo = function (e) {
            const backToMainMenuBtn = e.target.closest('.menu__return-link');
            if (!backToMainMenuBtn) return;
            const currentLi = e.currentTarget;

            currentLi
              .querySelectorAll('.-open')
              .forEach((openElt) => openElt.classList.remove('-open'));

            currentLi
              .querySelectorAll('[aria-expanded="true"]')
              .forEach((ariaTrueElt) =>
                ariaTrueElt.setAttribute('aria-expanded', 'false'),
              );

            currentLi.classList.remove('-open');
            backToMainMenuBtn.remove();
          };

          const toggleLevelThree = function () {
            const isItemOpen = this.getAttribute('aria-expanded') === 'true';

            this.setAttribute('aria-expanded', !isItemOpen);

            this.closest('.menu__item').classList.toggle('-open');
          };

          quickLinkMenu.addEventListener('click', (e) => toggleMobileNav(e));
          levelOneLinks.forEach((link) => {
            link.addEventListener('click', showLevelTwo);
          });
          menuItems.forEach((menuItem) => {
            menuItem.addEventListener('click', (e) => hideLevelTwo(e));
          });
          levelTwoLinks.forEach((link) => {
            link.addEventListener('click', toggleLevelThree);
          });
        }

        // DESKTOP NAVIGATION
        if (isDesktop()) {
          let menuOpen = false;
          const openBtn = context.querySelector('.main-nav-burger__btn');
          const closeBtn = mainNav.querySelector('.menu-close');
          const expandableMenuItems = mainNav.querySelectorAll(
            '.menu__item.-expanded',
          );

          const toggleNavState = function () {
            menuOpen = !menuOpen;
            openBtn.setAttribute('aria-expanded', menuOpen);
            closeBtn.setAttribute('aria-expanded', menuOpen);

            if (menuOpen) {
              bodyElt.classList.add('-menu-opened');

              if (!htmlElt.classList.add('-fixed-screen')) {
                htmlElt.classList.add('-fixed-screen');
              }
            } else {
              bodyElt.classList.remove('-menu-opened');
              htmlElt.classList.remove('-fixed-screen');
              expandableMenuItems.forEach((item) =>
                item.classList.remove('-open'),
              );

              mainNav.classList.remove('-full-height');
            }
          };

          const openNav = function () {
            toggleNavState();
          };

          const closeNav = function () {
            toggleNavState();
          };

          const showNavitems = function (e) {
            const menuItem = e.target.closest('.menu__item.-expanded');
            const keyboardNav = e.code === 'Escape' || e.code === 'Enter';

            // IF MENU ITEM HOVERED ALREADY HAS -opened CLASS, STOP THE CODE
            if (
              !keyboardNav &&
              (!menuItem || menuItem.classList.contains('-open'))
            )
              return;

            // REMOVE -opened ON ALL OTHER ELEMENTS
            expandableMenuItems.forEach((item) => {
              if (item !== menuItem) item.classList.remove('-open');
            });

            const menuItemparent = menuItem
              .closest('.menu')
              .closest('.menu__item.-expanded');

            // ADD -opened ON ITEM AND ITS PARENT IF ANY
            if (menuItemparent) menuItemparent.classList.add('-open');
            menuItem.classList.toggle('-open');
          };

          openBtn.addEventListener('click', openNav);
          closeBtn.addEventListener('click', closeNav);
          window.addEventListener('keydown', function (e) {
            if (
              e.code !== 'Escape' ||
              !document.querySelector('body').classList.contains('-menu-opened')
            )
              return;

            closeNav();
          });
          window.addEventListener('click', function (e) {
            if (
              e.target.closest('.block-ville-saint-denis-common-menu-main') ||
              e.target.closest('.main-nav-burger') ||
              !document.querySelector('body').classList.contains('-menu-opened')
            )
              return;

            closeNav();
          });

          mainNav.addEventListener('mouseover', (e) => showNavitems(e));
          mainNav.addEventListener('keydown', (e) => {
            if (e.code !== 'Enter' && e.code !== 'Escape') return;
            showNavitems(e);
          });

          expandableMenuItems.forEach((item) => {
            item.addEventListener('mouseleave', function () {
              item.classList.remove('-open');
            });
          });
        }

        window.addEventListener('scroll', function () {
          const headerHeight = header.offsetHeight;

          if (window.scrollY > headerHeight) {
            if (!bodyElt.classList.contains('-fixed-header')) {
              bodyElt.classList.add('-fixed-header');
            }
          } else {
            bodyElt.classList.remove('-fixed-header');
          }
        });
      });
    },
  };

  Drupal.behaviors.headerSearch = {
    attach(context) {
      once('headerSearch', '.site-header .header__search', context).forEach(
        (mainSearch) => {
          const htmlElt = context.querySelector('html');
          const closeBtn = mainSearch.querySelector(
            '.header__search__content__form__btn-close',
          );
          const openBtn = mainSearch.querySelector(
            '.header__search__content__btn-open',
          );

          const toggleClassElt = () => {
            htmlElt.classList.toggle('-fixed-screen');
            mainSearch.classList.toggle('-show-search');
          };

          if (window.innerWidth < 768) {
            openBtn.addEventListener('click', function () {
              toggleClassElt();

              openBtn.setAttribute('aria-expanded', true);
              closeBtn.setAttribute('aria-expanded', false);
            });

            closeBtn.addEventListener('click', function () {
              toggleClassElt();

              openBtn.setAttribute('aria-expanded', false);
              closeBtn.setAttribute('aria-expanded', true);
            });
          }
        },
      );
    },
  };

  Drupal.behaviors.carrouselParagraph = {
    attach(context) {
      const carrouselParagraph = once(
        'carrouselParagraph',
        '.paragraph--type--carrousel-tarifs .field--name-field-textes-formates-longs, .paragraph--type--carrousel-photo .field--name-field-reference-media-images, .paragraph--type--carrousel-vignettes .field--name-field-ref-vignettes-liens, .paragraph--type--carrousel-video .field--name-field-reference-media-videos',
        context,
      );

      carrouselParagraph.forEach((slider) => {
        movePrevBtnBeforeAfterSlick(slider);
        $(slider).slick({
          mobileFirst: true,
          dots: false,
          arrows: false,
          variableWidth: true,
          prevArrow: `<button type="button" class="slick-prev"><span class="sr-only">Précédent</span></button>`,
          nextArrow: `<button type="button" class="slick-next"><span class="sr-only">Suivant</span></button>`,
          customPaging(slick, index) {
            return customDotsAccessibilityTxt(index);
          },
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: true,
                dots: true,
              },
            },
          ],
        });
      });
    },
  };

  Drupal.behaviors.slider7ImagesCarrousel = {
    attach(context) {
      const slider7ImagesCarrousel = once(
        'carrouselParagraph',
        '.paragraph--type--slider-7-images .field--name-field-slides',
        context,
      );

      slider7ImagesCarrousel.forEach((slider) => {
        movePrevBtnBeforeAfterSlick(slider);
        $(slider).slick({
          mobileFirst: true,
          dots: true,
          arrows: true,
          variableWidth: true,
          prevArrow: `<button type="button" class="slick-prev"><span class="sr-only">Précédent</span></button>`,
          nextArrow: `<button type="button" class="slick-next"><span class="sr-only">Suivant</span></button>`,
          customPaging(slick, index) {
            return customDotsAccessibilityTxt(index);
          },
        });
      });
    },
  };

  Drupal.behaviors.evenementSelectionCarrousel = {
    attach(context) {
      const evenementSelectionCarrousel = once(
        'evenementSelectionCarrousel',
        '.view-id-evenement_selection .item-list > ul, .rebond-evenements .item-list > ul',
        context,
      );

      evenementSelectionCarrousel.forEach((slider) => {
        movePrevBtnBeforeAfterSlick(slider);
        addFocusableLink(slider);
        $(slider)
          .on('init', function () {
            setTimeout(() => {
              $(this).find('.slick-slide .node > a').attr('tabindex', '0');
            }, 0);
          })
          .slick({
            mobileFirst: true,
            dots: false,
            arrows: false,
            variableWidth: true,
            centerMode: false,
            prevArrow: `<button type="button" class="slick-prev"><span class="sr-only">Précédent</span></button>`,
            nextArrow: `<button type="button" class="slick-next"><span class="sr-only">Suivant</span></button>`,
            customPaging(slick, index) {
              return customDotsAccessibilityTxt(index);
            },
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  dots: true,
                },
              },
              {
                breakpoint: 1279,
                settings: {
                  arrows: true,
                  dots: true,
                },
              },
            ],
          });
      });
    },
  };

  Drupal.behaviors.homeCarrouselHero = {
    attach(context) {
      const homeCarrouselHero = once(
        'homeCarrouselHero',
        '.path-frontpage .home .field--name-field-carrousel > .field__items, .path-home .home .field--name-field-carrousel > .field__items',
        context,
      );

      homeCarrouselHero.forEach((slider) => {
        $(slider).slick({
          mobileFirst: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          centerMode: false,
          customPaging(slick, index) {
            return customDotsAccessibilityTxt(index);
          },
        });
      });
    },
  };

  Drupal.behaviors.homeProfil = {
    attach(context) {
      const homeProfil = once(
        'homeProfil',
        '.path-home .home .field--name-field-acces-rapides-profil, .path-frontpage .home .field--name-field-acces-rapides-profil',
        context,
      );

      const parameter = {
        mobileFirst: true,
        dots: false,
        arrows: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 767,
            settings: 'unslick',
          },
        ],
      };

      homeProfil.forEach((slider) => {
        $(slider).slick(parameter);

        reInitSlick(slider, parameter);
      });
    },
  };

  Drupal.behaviors.lienRapideCarrousel = {
    attach(context) {
      const lienRapideCarrousel = once(
        'lienRapideCarrousel',
        '.path-frontpage .home .field--name-field-acces-rapides-lien-rapide, .path-home .home .field--name-field-acces-rapides-lien-rapide, .paragraph--type--slider-de-liens .field--name-field-liens-rapides',
        context,
      );

      const parameter = {
        mobileFirst: true,
        dots: false,
        arrows: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: 'unslick',
          },
        ],
      };

      lienRapideCarrousel.forEach((slider) => {
        $(slider).slick(parameter);

        reInitSlick(slider, parameter, 1280);
      });
    },
  };

  Drupal.behaviors.publicationCarrousel = {
    attach(context) {
      const publicationCarrousel = once(
        'publicationCarrousel',
        '.path-frontpage .home .home__contents__publications .item-list > ul, .path-home .home .home__contents__publications .item-list > ul',
        context,
      );

      publicationCarrousel.forEach((slider) => {
        movePrevBtnBeforeAfterSlick(slider);
        $(slider).slick({
          mobileFirst: true,
          dots: false,
          arrows: false,
          variableWidth: true,
          infinite: true,
          prevArrow: `<button type="button" class="slick-prev"><span class="sr-only">Précédent</span></button>`,
          nextArrow: `<button type="button" class="slick-next"><span class="sr-only">Suivant</span></button>`,
          customPaging(slick, index) {
            return customDotsAccessibilityTxt(index);
          },
          responsive: [
            {
              breakpoint: 767,
              settings: {
                dots: true,
              },
            },
            {
              breakpoint: 1279,
              settings: {
                arrows: true,
                dots: true,
              },
            },
          ],
        });
      });
    },
  };

  Drupal.behaviors.homeCarrousel = {
    attach(context) {
      const homeCarrousel = once(
        'homeCarrousel',
        '.path-frontpage .home .field--name-field-sondage, .path-frontpage .home .home__contents__rendez-vous-list .item-list > ul',
        context,
      );

      homeCarrousel.forEach((slider) => {
        movePrevBtnBeforeAfterSlick(slider);

        $(slider).slick({
          mobileFirst: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          prevArrow: `<button type="button" class="slick-prev"><span class="sr-only">Précédent</span></button>`,
          nextArrow: `<button type="button" class="slick-next"><span class="sr-only">Suivant</span></button>`,
          customPaging(slick, index) {
            return customDotsAccessibilityTxt(index);
          },
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
              },
            },
          ],
        });
      });
    },
  };

  Drupal.behaviors.externalLink = {
    attach(context) {
      // const host = window.location.host.replace(/\./g, '\\.');
      // const match = new RegExp(`^http(s)?:\\/\\/(?!${host})`);

      // Liens externes flaggués comme externe par un attribut rel
      // s'ouvrent dans une nouvelle fenetre.
      $(once('html', 'a:not(.language-link):not(.block-link)', context)).on(
        'click',
        function (event) {
          const target = event.currentTarget;
          const { href } = target;
          if (href === '#') {
            return;
          }

          if (Drupal.url.isLocal(href) === true) {
            return;
          }

          if ($(this).attr('target') && $(this).attr('target') !== '_blank') {
            return;
          }

          $(this).attr('target', '_blank');

          // if (match.test(href) || target.rel === 'external') {
          //   event.stopPropagation();
          //   window.open(href, target);
          //   return false;
          // }
        },
      );
    },
  };

  Drupal.behaviors.toTopButton = {
    attach(context) {
      $(once('toTopButton', '.to-top'), context).each(function () {
        const scrollTopPosition = 400;
        const $buttonSlideTop = $(this);

        $(window).scroll(function () {
          const scroll = $(window).scrollTop();
          if (scroll > scrollTopPosition) {
            $buttonSlideTop.addClass('-show');
          } else {
            $buttonSlideTop.removeClass('-show');
          }
        });

        $(this).on('click', function () {
          $('html, body').animate(
            {
              scrollTop: 0,
            },
            0,
          );
        });
      });
    },
  };

  Drupal.behaviors.desktopSummary = {
    attach(context) {
      $(
        once('desktopSummary', '.node__content__contents.-has-summary'),
        context,
      ).each(function (element) {
        const summary = $('.summary', element);
        const summaryElt = $(
          '.node__content__contents__summary__container',
          element,
        );
        const summaryItems = summary.find('ul li');
        const summaryTop = $('.node__content__contents').offset().top;
        const headerHeight =
          $('header.site-header').position().top +
          $('header.site-header').height() +
          100;
        const sections = $(
          '.node__content__contents__paragraphs [data-summary-id]',
          element,
        );

        // add class active first element
        summary
          .find('.summary__content > .item-list > ul > li:first-child')
          .addClass('-active');

        if (!isDesktop()) {
          return;
        }

        // sticky summary
        $(window).on('scroll', function () {
          const scrollY = $(window).scrollTop();

          if (scrollY + headerHeight > summaryTop) {
            if (!summaryElt.hasClass('sticky')) {
              summaryElt.addClass('sticky');
            }
          } else {
            summaryElt.removeClass('sticky');
          }

          sections.each(function () {
            const sectionHeight = $(this).outerHeight();
            const sectionTop = $(this).offset().top - 140;
            const sectionId = $(this).attr('data-summary-id');

            if (
              scrollY > sectionTop - 140 &&
              scrollY <= sectionTop + sectionHeight + 140
            ) {
              $(
                '.node__content__contents__summary .-active',
                element,
              ).removeClass('-active');
              $(
                `.node__content__contents__summary a[data-summary-id*=${sectionId}]`,
                element,
              )
                .parent()
                .addClass('-active');
            }
          });
        });

        summaryItems.on('click', function () {
          summary.find('ul .-active').removeClass('-active');

          $(this).addClass('-active');
        });
      });
    },
  };

  Drupal.behaviors.mobileSummary = {
    attach(context) {
      once(
        'mobileSummary',
        '.node__content__contents.-has-summary',
        context,
      ).forEach(function (element) {
        const summary = $('.summary', element);
        if (isDesktop()) {
          return;
        }

        const activeElTxt = summary.find('ul > li.-active > a').text();

        // add span to .item-list before ul
        summary
          .find('.summary__content > .item-list')
          .prepend(`<span>${activeElTxt}</span>`);

        summary.find('.summary__content').on('click', function () {
          $(this).toggleClass('-show-mobile');
          // const target = $(event.target);

          // if (target.is('a')) {
          //   summary
          //     .find('.summary__content > .item-list > span')
          //     .text(target.text());

          //   summary.find('ul > li.-active').removeClass('-active');

          //   target.parent().addClass('-active');
          // }
        });
      });
    },
  };

  Drupal.behaviors.summarySmoothScroll = {
    attach(context) {
      once(
        'summarySmoothScroll',
        '.node__content__contents.-has-summary',
        context,
      ).forEach(function (element) {
        const summary = $('.summary', element);
        const link = summary.find('.item-list a');

        link.on('click', function () {
          const summaryId = $(this).attr('data-summary-id');
          const block = $(
            `.node__content__contents__paragraphs #${summaryId}`,
            element,
          );
          let positionTop = 112;
          const rootVariable = getComputedStyle(document.documentElement)
            .getPropertyValue('--drupal-displace-offset-top')
            .replace(/[^.\d]/g, '');

          if (isDesktop()) {
            positionTop = 140;
          }

          if (!block || block.length === 0) return;

          const blockTop = block.offset().top;
          let scrollTop = blockTop - positionTop - rootVariable;

          if (!$('body').hasClass('-fixed-header')) scrollTop -= positionTop;

          $('html, body').animate(
            {
              scrollTop,
            },
            50,
          );
        });
      });
    },
  };
  Drupal.behaviors.accordeon = {
    attach(context) {
      $(
        once(
          'accordeon',
          '.paragraph--type--accordeon, .paragraph--type--focus-faq, .paragraph--type--faq',
        ),
        context,
      ).each(function (element) {
        const volet = $('.volet', element);

        function linkContentRemoveTab() {
          volet.find('a').attr('tabindex', '-1');

          const activeVolet = $('.volet.-active', element);

          if (activeVolet) {
            activeVolet.find('a').removeAttr('tabindex');
          }
        }

        linkContentRemoveTab();

        volet.on('click', function () {
          if (!$(this).hasClass('-active')) {
            const voletsActive = $('.volet.-active', element);
            const btnVoletsActive = voletsActive.find('button');

            toggleAttr(btnVoletsActive, 'aria-expanded');

            voletsActive.removeClass('-active');
            voletsActive.find('.field--type-text-long');
          }

          $(this).toggleClass('-active');

          toggleAttr($(this).find('button'), 'aria-expanded');
          linkContentRemoveTab();
        });
      });
    },
  };

  Drupal.behaviors.elusParagraph = {
    attach(context) {
      $(once('elusParagraph', '.paragraph--type--elus'), context).each(
        function (paragraph) {
          const buttons = $('.paragraph__heading button', paragraph);
          const firstParagraphElus = $('.paragraph--type--elus').first();

          firstParagraphElus.addClass('-active');
          toggleAttr(firstParagraphElus.find('button'), 'aria-expanded');

          buttons.on('click', function () {
            const parent = $(this).closest('.paragraph--type--elus');
            const activeParent = $('.-active', paragraph);
            const btnActive = $('.paragraph--type--elus.-active button');

            if (!parent.hasClass('-active')) {
              toggleAttr(btnActive, 'aria-expanded');
              activeParent.removeClass('-active');
            }

            parent.toggleClass('-active');

            toggleAttr($(this), 'aria-expanded');
          });
        },
      );
    },
  };

  Drupal.behaviors.filtersFacetToggle = {
    attach(context) {
      once('filtersFacetToggle', '.filters-view', context).forEach(
        (filterBlock) => {
          const openBtn = filterBlock.querySelector('.filters-view__open-btn');
          const closeBtn = filterBlock.querySelector(
            '.filters-view__close-btn',
          );
          const facetsContainer = filterBlock.querySelector(
            '.filters-view__wrapper',
          );
          const facetsItems = facetsContainer.querySelectorAll(
            '.facets-widget__block',
          );
          const facetsLists = facetsContainer.querySelectorAll(
            '.facets-widget__list:not(.-gratuit)',
          );

          const openFilters = function () {
            openBtn.setAttribute('aria-expanded', 'true');
            context.querySelector('html').classList.add('-fixed-screen');
          };

          const closeFilters = function () {
            openBtn.setAttribute('aria-expanded', 'false');
            facetsItems.forEach((item) => item.classList.remove('-is-open'));
            context.querySelector('html').classList.remove('-fixed-screen');
          };

          const addPlaceholder = function (facetBlock) {
            const facetReset = facetBlock.querySelector('.facets-reset');
            const facetsTitle = facetBlock.querySelector(
              '.facets-widget__title',
            ).textContent;
            const labelPlaceholder = Drupal.t(`Selectionner - ${facetsTitle}`);

            if (!facetReset) return;
            const facetActive = facetBlock.querySelectorAll('.is-active');

            let placeholderText =
              facetActive[0].querySelector('.facet-item__value').textContent ||
              facetReset.querySelector('.facet-item__value').textContent;

            if (facetActive.length > 1) {
              facetActive.forEach((facet, index) => {
                if (index === 0) return;
                placeholderText += `, ${
                  facet.querySelector('.facet-item__value').textContent
                }`;
              });
            }

            const facetPlaceholder = `
              <span role="button" tabindex="0" class="facets-widget__placeholder" aria-expanded="false" aria-haspopup="true" aria-label="${labelPlaceholder}">${placeholderText}</span>`;

            facetReset.insertAdjacentHTML('beforebegin', facetPlaceholder);
          };

          const expandFacet = function (e) {
            if (window.innerWidth < 768) {
              const facetTitle = e.target.closest('.facets-widget__title');
              if (!facetTitle) return;
              Array.from(facetsItems)
                .filter(
                  (item) =>
                    item !== facetTitle.closest('.facets-widget__block'),
                )
                .forEach((item) => item.classList.remove('-is-open'));
              facetTitle
                .closest('.facets-widget__block')
                .classList.toggle('-is-open');
            } else {
              const facetList = e.target.closest(
                '.facets-widget__list:not(.-gratuit)',
              );
              if (!facetList) return;

              Array.from(facetsLists)
                .filter((list) => list !== facetList)
                .forEach((list) => list.classList.remove('-expanded'));

              facetList.classList.toggle('-expanded');
            }
          };

          window.addEventListener('load', () => {
            if (window.innerWidth < 768) return;
            facetsItems.forEach((block) => {
              addPlaceholder(block);
            });
          });

          const collapseFacets = function (e) {
            if (e.target.closest('.facets-widget__list')) return;
            facetsLists.forEach((list) => list.classList.remove('-expanded'));
          };

          openBtn.addEventListener('click', openFilters);
          closeBtn.addEventListener('click', closeFilters);
          facetsContainer.addEventListener('click', (e) => expandFacet(e));
          facetsContainer.addEventListener('keydown', (e) => {
            if (e.code !== 'Enter' && e.code !== 'Space') return;
            if (e.code === 'Space') e.preventDefault();
            expandFacet(e);
          });
          window.addEventListener('click', (e) => collapseFacets(e));
          window.addEventListener('keydown', (e) => {
            if (e.code !== 'Escape') return;
            collapseFacets(e);
          });
        },
      );
    },
  };

  Drupal.behaviors.rechercheFacetToggle = {
    attach(context) {
      once('rechercheFacetToggle', '.search-filters', context).forEach(
        (eventFilterBlock) => {
          const openBtn = eventFilterBlock.querySelector(
            '.search-filters__open-btn',
          );
          const closeBtn = eventFilterBlock.querySelector(
            '.search-filters__close-btn',
          );
          const facetsContainer = eventFilterBlock.querySelector(
            '.search-filters__wrapper',
          );
          const facetsItems = facetsContainer.querySelectorAll(
            '.facets-widget__block',
          );

          const openFilters = function () {
            openBtn.setAttribute('aria-expanded', 'true');
            context.querySelector('html').classList.add('-fixed-screen');
          };

          const closeFilters = function () {
            openBtn.setAttribute('aria-expanded', 'false');
            context.querySelector('html').classList.remove('-fixed-screen');
          };

          const expandFacet = function (e) {
            if (window.innerWidth < 768) {
              const facetTitle = e.target.closest('.facets-widget__title');
              if (!facetTitle) return;
              Array.from(facetsItems)
                .filter(
                  (item) =>
                    item !== facetTitle.closest('.facets-widget__block'),
                )
                .forEach((item) => item.classList.remove('-is-open'));
              facetTitle
                .closest('.facets-widget__block')
                .classList.toggle('-is-open');
            }
          };

          openBtn.addEventListener('click', openFilters);
          closeBtn.addEventListener('click', closeFilters);
          facetsContainer.addEventListener('click', (e) => expandFacet(e));
        },
      );
    },
  };

  Drupal.behaviors.facetDropdownToggle = {
    attach(context) {
      once(
        'facetDropdownToggle',
        '.view-display-id-page_actualites .block-facet-blockthematiques-actualites, .view-display-id-presse .block-facet-blockthematiques-presse, .view-display-id-page_actualites .block-facet-blockquartiers-actualites',
        context,
      ).forEach((eventFilterBlock) => {
        const select = eventFilterBlock.querySelector(
          'div.item-list__dropdown',
        );

        const togglStateFacet = () => {
          const attr = select.getAttribute('aria-expanded');

          if (attr === 'false') {
            select.setAttribute('aria-expanded', true);
          } else {
            select.setAttribute('aria-expanded', false);
          }
        };

        if (typeof select !== 'undefined') {
          select.addEventListener('click', togglStateFacet);
        }

        window.addEventListener('keydown', (e) => {
          if (e.code !== 'Enter') return;
          togglStateFacet();
        });
      });
    },
  };

  Drupal.behaviors.assoFacetToggle = {
    attach(context) {
      once('assoFacetToggle', '.asso-filters', context).forEach(
        (assoFilterBlock) => {
          const openBtn = assoFilterBlock.querySelector(
            '.asso-filters__open-btn',
          );
          const closeBtn = assoFilterBlock.querySelector(
            '.asso-filters__close-btn',
          );
          const facetsContainer = assoFilterBlock.querySelector(
            '.asso-filters__wrapper',
          );
          const facetsItems = facetsContainer.querySelectorAll(
            '.facets-widget__block',
          );

          const openFilters = function () {
            openBtn.setAttribute('aria-expanded', 'true');
            context.querySelector('html').classList.add('-fixed-screen');
          };

          const closeFilters = function () {
            openBtn.setAttribute('aria-expanded', 'false');
            context.querySelector('html').classList.remove('-fixed-screen');
          };

          const expandFacet = function (e) {
            if (window.innerWidth < 768) {
              const facetTitle = e.target.closest('.facets-widget__title');
              if (!facetTitle) return;
              Array.from(facetsItems)
                .filter(
                  (item) =>
                    item !== facetTitle.closest('.facets-widget__block'),
                )
                .forEach((item) => item.classList.remove('-is-open'));
              facetTitle
                .closest('.facets-widget__block')
                .classList.toggle('-is-open');
            }
          };

          openBtn.addEventListener('click', openFilters);
          closeBtn.addEventListener('click', closeFilters);
          facetsContainer.addEventListener('click', (e) => expandFacet(e));
        },
      );
    },
  };

  Drupal.behaviors.modalVideo = {
    attach(context) {
      once('modalVideo', 'body', context).forEach((page) => {
        const htmlElt = context.querySelector('html');
        const videos = page.querySelectorAll('.media--type-oembed-video');
        const playButton = page.querySelectorAll(
          '.media--type-oembed-video__play-button',
        );
        const modal = page.querySelector('.modal-video');
        const closeModal = modal.querySelector(
          '.modal-video__container__button',
        );
        const focusableElements = modal.querySelectorAll(
          'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',
        );
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement =
          focusableElements[focusableElements.length - 1];

        if (videos === null) {
          modal.remove();
          return;
        }

        document.addEventListener('youtube_loaded', function () {
          videos.forEach((video) => {
            const iframeVideo = video.querySelector('iframe');
            iframeVideo.setAttribute(
              'allow',
              'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
            );

            iframeVideo.removeAttribute('width');
            iframeVideo.removeAttribute('height');
          });
        });

        window.addEventListener('load', function () {
          // OnClick show modal
          const showModal = (e) => {
            e.target.setAttribute('aria-expanded', true);
            const parent = e.target.parentNode;
            const videoClone = parent
              .querySelector('.field--name-field-media-oembed-video')
              .cloneNode(true);
            const modalContent = modal.querySelector(
              '.modal-video__container__content',
            );

            modalContent.appendChild(videoClone);

            modal.classList.add('-show-modal');
            htmlElt.classList.add('-fixed-screen');

            const videoContainer = modalContent.querySelector(
              '.field--name-field-media-oembed-video',
            );

            const iframeVideo = videoContainer.querySelector('iframe');

            if (!iframeVideo) return;

            setTimeout(() => {
              let video;

              if (iframeVideo.closest('.youtube_player')) {
                video = iframeVideo;
              } else {
                video =
                  iframeVideo.contentDocument ||
                  iframeVideo.contentWindow.document;
                video = video.querySelector('iframe');
              }

              if (video) {
                let editableVideoSrc = video.getAttribute('src');

                editableVideoSrc += '&autoplay=1';
                video.setAttribute('src', editableVideoSrc);
              }
            }, 500);

            closeModal.focus();
          };

          // OnClick hide modal
          const hideModal = () => {
            const videoContent = modal.querySelector(
              '.field--name-field-media-oembed-video',
            );

            if (
              page.querySelector(
                '.media--type-oembed-video__play-button[aria-expanded="true"]',
              )
            ) {
              page
                .querySelector(
                  '.media--type-oembed-video__play-button[aria-expanded="true"]',
                )
                .focus();
            }

            if (videoContent) {
              videoContent.remove();
              modal.classList.remove('-show-modal');
              htmlElt.classList.remove('-fixed-screen');

              playButton.forEach((btn) => {
                btn.setAttribute('aria-expanded', false);
              });
            }
          };

          playButton.forEach((btn) => {
            btn.addEventListener('click', (e) => showModal(e));
          });

          closeModal.addEventListener('click', hideModal);

          window.addEventListener('keydown', (e) => {
            if (e.code !== 'Escape') return;
            hideModal();
          });

          modal.addEventListener('keydown', function (e) {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
              return;
            }

            if (e.shiftKey) {
              if (document.activeElement === firstFocusableElement) {
                e.preventDefault();
                lastFocusableElement.focus();
              }
            } else if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          });
        });
      });
    },
  };

  Drupal.behaviors.bandeauAlerte = {
    attach(context) {
      $(
        once(
          'bandeauAlerte',
          '.block-ville-saint-denis-common-bandeau-alerte',
          context,
        ),
      ).each(function (element) {
        const buttonsClose = $('.bandeau-alerte__item__btn', element);
        const alertes = $('.bandeau-alerte__item', element);

        if (!alertes.length) {
          return false;
        }

        function insertBouton(alert) {
          const buttonHtml = $(
            "<button type='button' class='bandeau-alerte__item__voir-plus'><span>En savoir plus</span></button>",
          );
          buttonHtml.insertAfter(alert.find('.bandeau-alerte__item__texte'));
        }

        function checkHeightText(alert) {
          const text = alert.find('.bandeau-alerte__item__texte');

          const child = text.find('.bandeau-alerte__item__texte__content');

          if (child.outerHeight() <= text.height()) {
            alert.find('.bandeau-alerte__item__voir-plus').remove();
          } else if (
            child.outerHeight() >= text.height() &&
            !alert.find('.bandeau-alerte__item__voir-plus').length
          ) {
            insertBouton(alert);
          }
        }

        alertes.each(function () {
          if (
            !getCookie($(this).attr('data-id')) ||
            getCookie($(this).attr('data-id')) !==
              $(this).attr('data-date-debut')
          ) {
            $(this).addClass('-show-alerte');
          }

          checkHeightText($(this));
        });

        buttonsClose.on('click', function () {
          const bandeau = $(this).closest('.bandeau-alerte__item');

          setCookie(bandeau.attr('data-id'), bandeau.attr('data-date-debut'));

          bandeau.animate(
            {
              height: 0,
              opacity: 0,
              'margin-bottom': 0,
              'padding-top': 0,
            },
            'slow',
            function () {
              bandeau.removeClass('-show-alerte');
            },
          );
        });

        alertes.on('click', '.bandeau-alerte__item__voir-plus', function () {
          $(this).parent().toggleClass('-all-texte');
        });

        $(window).on('resize', function () {
          alertes.each(function () {
            if ($(this).hasClass('-all-texte')) {
              return;
            }

            checkHeightText($(this));
          });
        });
      });
    },
  };

  Drupal.behaviors.selectSortSubmit = {
    attach(context) {
      once(
        'selectSortSubmit',
        '.path-services #views-exposed-form-landing-pages-content-listing-page-services, .path-recherche .view-recherche #ows-search-views-sort-form',
        context,
      ).forEach((element) => {
        const select = element.querySelector('.form-select');

        select.addEventListener('change', () => {
          element.submit();
        });
      });
    },
  };

  Drupal.behaviors.modaleConfirmationContact = {
    attach(context) {
      once(
        'modaleConfirmationContact',
        '.path-contact form.page-contact .modale-confirmation.-active',
        context,
      ).forEach((modal) => {
        const body = document.querySelector('body');
        const closeBtn = modal.querySelector(
          '.modale-confirmation__infos__close',
        );

        modal.querySelector('.modale-confirmation__infos').focus();

        const hideModal = () => {
          modal.classList.remove('-active');
          closeBtn.setAttribute('aria-expanded', 'false');
        };

        body.addEventListener('click', function (e) {
          if (
            e.target.classList.contains('modale-confirmation') ||
            e.target.classList.contains('modale-confirmation__infos__close')
          ) {
            hideModal();
          }
        });

        window.addEventListener('keydown', (e) => {
          if (e.code !== 'Escape') return;
          hideModal();
        });

        closeBtn.addEventListener('keydown', (e) => {
          if (e.code !== 'Enter') return;
          hideModal();
        });

        modal.addEventListener('focusout', function (e) {
          if (!modal.contains(e.relatedTarget)) hideModal();
        });
      });
    },
  };
  Drupal.behaviors.resizeIframes = {
    attach(context) {
      once('resizeIframes', 'iframe', context).forEach((iframe) => {
        if (iframe.src.includes('vimeo') || iframe.src.includes('youtu'))
          return;
        $(iframe).iFrameResize([{ log: true }]);
      });
    },
  };

  Drupal.behaviors.scriptResizeBenevolat = {
    attach() {
      function updateHeight() {
        const div = document.querySelector(
          '.path-benevolat #api-engagement-widget',
        );

        if (div) {
          if (div.offsetWidth < 640) div.style.height = '3500px';
          else if (div.offsetWidth < 1024) div.style.height = '1900px';
          else div.style.height = '1350px';
        }
      }

      updateHeight();
      window.addEventListener('resize', updateHeight);
    },
  };

  Drupal.behaviors.viewExposedAnnuaire = {
    attach(context) {
      once(
        'exposed-form-annuaire',
        '.path-annuaire-associations #block-ville-saint-denis-search-form-annuaire, .path-annuaire-services #block-ville-saint-denis-search-form-annuaire-services',
        context,
      ).forEach((form) => {
        const reset = form.querySelector('.button--reset');
        const search = form.querySelector('.form-item-text input');
        const submit = form.querySelector('input[type="submit"]');

        function handleReset(e) {
          if (
            e.type === 'click' ||
            (e.type === 'keydown' && e.key === 'Enter')
          ) {
            search.value = '';
            submit.click();
          }
        }

        if (search.value !== '') {
          form.classList.add('-filters');
        }

        reset.addEventListener('click', handleReset);
        reset.addEventListener('keydown', handleReset);
      });
    },
  };

  Drupal.behaviors.AffichageActiviteAnnuaire = {
    attach(context) {
      once(
        'toggle-affichage-activites',
        '.path-annuaire-associations .fiche-contact__activities__button',
        context,
      ).forEach((button) => {
        const defaultText = Drupal.t('Afficher toutes les activités');
        const hideText = Drupal.t('Masquer toutes les activités');

        button.addEventListener('click', function () {
          const btn = this;
          const attr = btn.getAttribute('aria-expanded');
          btn.closest('.fiche-contact__activities').classList.toggle('-show');

          if (attr === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = defaultText;
          } else {
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = hideText;
          }
        });
      });
    },
  };
})(jQuery, once);
